import type { DocumentListResponse } from "@/types/eryndal";
import { apiGet } from "./client";

export interface ListDocumentsParams {
  limit?: number;
  offset?: number;
  search?: string;
}

export async function listDocuments(
  params: ListDocumentsParams = {},
): Promise<DocumentListResponse> {
  const search = new URLSearchParams();
  if (params.limit !== undefined) search.set("limit", String(params.limit));
  if (params.offset !== undefined) search.set("offset", String(params.offset));
  if (params.search) search.set("search", params.search);
  const qs = search.toString();
  return apiGet<DocumentListResponse>(`/documents${qs ? `?${qs}` : ""}`);
}
